import TOI_LOGO from "./TOI_LOGO.png";
import COMPANY_LOGO from './vishwakarma.png'
export const ARTICLES_LIST = [
  {
    title: "Thoughts on Integrating Nature Within Ahmedabad’s Property Development",
    desc: "",
    id: 1,
    logo: TOI_LOGO,
    link: "https://www.zeebiz.com/agencies/vishwanath-builders-unveils-sarathya-west-the-tallest-residential-building-in-shela-269199",
  },
  {
    title: "Understanding the Shift to RERA Carpet Area: A New Era in Real Estates",
    desc: "",
    id: 2,
    logo:COMPANY_LOGO,
    link: "https://vishwanathbuilders.com/understanding-the-shift-to-rera-carpet-area-a-new-era-in-real-estates.html",
  },
  // {
  //   title: "",
  //   desc: "",
  //   id: 3,
  //   link: "https://www.hindustantimes.com/brand-stories/vishwanath-builders-unveils-sarathya-west-the-tallest-residential-building-in-shela-101702897672373.html?utm_source=whatsapp&utm_medium=social&utm_campaign=ht_site",
  // },
];
